import React, { useEffect, useState, useContext } from "react";
import Navbar from "./Navbar";
import axios from "axios";
import { useCookies } from 'react-cookie';
import Sidebar from "./Sidebar";
import { useMediaQuery } from "@mui/material";

const Layout = ({ isAuthenticated, children }) => {
    const [userDetails, setUserDetails] = useState(null);
    const [cookies] = useCookies(['jwtToken']);
    const jwtToken = cookies['jwtToken'];
    const isDesktop = useMediaQuery("(min-width: 720px)");
// console.log(isDesktop,"popo")
    // console.log(isAuthenticated, jwtToken)
    useEffect(() => {
        if (isAuthenticated) {


            const axiosInstance = axios.create({
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            // Fetch user details using Axios
            axiosInstance.get("https://efhp0mxmli.execute-api.ap-south-1.amazonaws.com/dev/validate-jwt")
                .then((response) => {
                    // console.log(response.data)
                    const data = response.data.message;
                    if (data.response_code === "USER_DETAILS_RECEIVED") {
                        setUserDetails(data.user);
                    }
                })
                .catch((error) => {
                    console.error("Failed to fetch user details:", error);
                });
        }
    }, [isAuthenticated, cookies]);

    if (isAuthenticated) {
        return (
            <>
                <Navbar userDetails={userDetails} />
                <div className="mt-3">
                    <div className="flex gap-4 w-full">
                        {isDesktop && (
                            <div className="secondCard">
                                <Sidebar />
                            </div>
                        )}
                        <div className="MainContent">
                            {children}
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div className="flex flex-auto">
                    {/* <Sidebar */}

                    <div className="grow">
                        <div>{children}</div>
                    </div>
                </div>
            </>
        );
    }
};

export default Layout;
